module.exports = "<div class=\"rm-chart chart-container\"><svg xmlns=http://www.w3.org/2000/svg class=chart width=100%></svg></div>";